// 杰锐德故事管理
import http from "@/jslibs/axios/http";

// 杰锐德故事列表
export const list = (data) => http.get("/v1/cms/CompanyHistory", data);

// 杰锐德故事新增
export const add = (data) => http.post("/v1/cms/CompanyHistory", data);

// 杰锐德故事编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/CompanyHistory/${uuid}`, data);

// 杰锐德故事删除
export const del = ({ cuuid }) => http.delete(`/v1/cms/CompanyHistory/${cuuid}`);

// 杰锐德故事详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/CompanyHistory/${cuuid}`, data);
